import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-get-code-step-modal',
  templateUrl: './get-code-step-modal.component.html',
  styleUrls: ['./get-code-step-modal.component.scss'],
})
export class GetCodeStepModalComponent {
  activeIndex = 1;

  constructor(private dialogRef: MatDialogRef<GetCodeStepModalComponent>) {}
  close() {
    this.dialogRef.close();
  }

  tab(index: any) {
    this.activeIndex = index;
  }

  next(index: any) {
    this.activeIndex = index + 1;
  }

  skip() {
    this.activeIndex = 5;
  }

  onOk() {
    this.dialogRef.close('ok');
  }
}
